import { observable, action } from 'mobx'
import http from 'src/helper/http'

export default class {
  @observable data = {
    inSubmit: false,
    userInfo: {
      uid: 0,
    },
    showlodingValue: true,
    nav: 1,
    loading: false,
    uploadPics: [], // 上传的图片
    reviewPics: [], // 预览图片
    faqHot: {
      hasMore: true,
      scroll: '',
      list: [],
    },
    qtype: 1,
    faqContent: {
      id: 0,
      question: '',
      answer: '',
    },
    feedbackList: {
      hasMore: true,
      scroll: '',
      list: [],
    },
    feedbackContent: {
      id: 0,
      content: '',
      reply: '',
      isReplied: 2,
      score: 0,
      isRead: 2,
    },
    toastContent: '',
    uploadModal: true,
    redCount: 0,
    feedbackShowList: [],
    reportShowList: [],
    rpIsShow: true,
    loadingContrl: false,
  }

  @action _handleImageChange(pic, base64, isDel) {
    console.log('_handleImageChange', pic, base64, isDel)
    if (isDel) {
      // 上传成功之后清空图片
      this.data.uploadPics = []
      this.data.reviewPics = []
      return
    }
    this.data.uploadPics.push(pic)
    this.data.reviewPics.push(base64)
  }

  @action addPath(path) {
    this.data.paths.push(path)
  }

  @action async feedbackAdd(map) {
    let d = await http.post('/web/feedback/add', map)
    if (d.code == 0) {
      console.log('提交成功')
      return d
    }
    console.log('提交失败')
    return d
  }

  @action setLoading(status) {
    this.data.loading = status
  }

  @action setQtype(qtype) {
    this.data.qtype = qtype || 1
  }

  @action setFaqContent(item) {
    this.data.faqContent = item
  }

  @action setFeedbackContent(item) {
    item.scoreY = item.score
    this.data.feedbackContent = item
  }

  @action async setToastContent(content) {
    this.data.toastContent = content
  }

  @action async setNav(nav) {
    this.data.nav = nav
  }

  @action async setScore(score) {
    this.data.feedbackContent.score = score
  }

  @action async setFaqHot(d) {
    this.data.faqHot = d
  }

  @action async faqHot() {
    let d = await http.post('/withoutsign/faq/list', { qtype: this.data.qtype })
    if (d && d.code == 0 && d.res.list && d.res.list != null) {
      this.setFaqHot(d.res || [])
    }
  }

  @action async feedbackGet(id) {
    let d = await http.post('/web/feedback/get', { id: id })
    if (d.code == 0) {
      this.setFeedbackContent(d.data)
    }
  }

  @action async feedbackList(refresh) {
    // let d = await http.post('/web/feedback/list', {})
    // if (d && d.code == 0 && d.data.list && d.data.list != null) {
    //   this.data.feedbackList = d.data
    // }
    this.data.showlodingValue = true
    if (this.data.inSubmit == false && (this.data.feedbackList.hasMore == true || refresh)) {
      this.data.inSubmit = true
      if (refresh == true) {
        this.data.feedbackList.scroll = ''
      }
      let d = await http.post('/web/feedback/list', { scroll: this.data.feedbackList.scroll || '' })

      this.data.feedbackList.scroll = d.data.scroll || ''
      this.data.feedbackList.hasMore = d.data.hasMore
      if (!d.data.list || (d.data.list && d.data.list.length == 0)) {
        this.data.feedbackList.hasMore = false
      }
      if (d && d.data && d.data.list) {
        if (refresh == true) {
          this.data.feedbackList.list = d.data.list || []
        } else {
          if (d.data.list.length > 0 && this.data.feedbackList.list) {
            this.data.feedbackList.list = this.data.feedbackList.list.concat(d.data.list) || []
          }
        }
      }
      this.data.inSubmit = false
      this.data.showlodingValue = false
    }

    let redCount = 0
    for (let i = 0; i < this.data.feedbackList.list.length; i++) {
      if (this.data.feedbackList.list[i].isRead == 2) {
        redCount++
      }
    }
    this.data.redCount = redCount
  }

  @action async feedbackScore(map) {
    if (this.data.inSubmit == false) {
      this.data.inSubmit == true
      let d = await http.post('/web/feedback/score', map)
      this.data.inSubmit == false
      return d
    }
  }

  @action async feedbackRead(id) {
    let d = await http.post('/web/feedback/read', { id: id })
    return d
  }

  // by Tang
  @action async getFeedbackReportList() {
    this.data.loadingContrl = true
    let d = await http.post('/web/feedback/class/list')
    if (d.code == 0) {
      this.data.loadingContrl = false
    }
    this.data.feedbackShowList = d && d.data && d.data.feedback
    this.data.reportShowList = d && d.data && d.data.report
    console.log(d)
  }
  @action async postFeedbackOrReport(frObj) {
    console.log(frObj)
    let d = await http.post('/withoutsign/feedback/store', {
      // id 是 ftype
      id: frObj.id,
      content: frObj.content,
      files: frObj.file,
      uid: frObj.uid,
      gid: frObj.gid,
      mid: frObj.mid,
      transactionId: frObj.transactionId,
    })
    console.log(d)
  }
  @action handleRpIsShow(bool) {
    this.data.rpIsShow = bool
  }
}



// WEBPACK FOOTER //
// src/store/app/service.js